import { IonSelect, IonSelectOption, IonRippleEffect, IonSearchbar, IonSegment, IonSegmentButton, IonAvatar, IonImg, IonSpinner, useIonRouter, IonRouterLink, IonRefresher, IonRefresherContent, IonChip, IonText, IonCardTitle, IonCardHeader, IonCardContent, IonGrid, IonRow, IonBackButton, IonButton, IonButtons, IonCard, IonCheckbox, IonCol, IonContent, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonNote, IonPage, IonTextarea, IonTitle, IonToolbar, useIonViewWillEnter } from "@ionic/react";
import { heartOutline, search, locationOutline, createOutline, listOutline, mapOutline, chevronForwardOutline, heart, wallet, menuOutline, addOutline, logoWebComponent, shuffleOutline, enterOutline, logOutOutline, cardOutline, sendOutline, qrCodeOutline, personCircle, send } from 'ionicons/icons';
import React, { useState, useEffect } from "react";
import { useParams } from 'react-router';
import { showTab, updateTab } from "../components/Tabs";
import { RouteComponentProps } from "react-router-dom";
import { Virtuoso } from 'react-virtuoso';


import { LANGUAGE, GetStr, LoadLanguage } from "../language/Language";
import { Storage } from '@capacitor/storage';   
import NServer, { UIElement, RegisterAppServices, handleRouteError } from "../components/NServer";
import { Browser } from '@capacitor/browser';
import Vault from '../components/Vault';
import { showAlert } from '../components/Alert';
import { GameInfo } from "../data/game_info";
import { ContentInfo, CreateContentInfo, FilterUniqueContent } from "../data/item";
import ContentWrapper from "../components/ContentWrapper";
import LocationSelector, { Location, locationName } from "../components/LocationSelector";
import ItemSelector from "../components/ItemSelector";

import './Main.css'; 

interface WalletProp extends RouteComponentProps<{
    tab : string
    }> 
{}

var index = 0;
const total = 20;
var noMoreLoadData = false;
var loading = false;

const TokenWallet : React.FC<WalletProp> = ({match}) => {
    
    const [usd, setUsd] = useState("");
    const [nToken, setNToken] = useState("");
    const [usdExchange, setUsdExchange] = useState("");
    const [ntkExchange, setNTKExchange] = useState("");
    const [hasWallet, setHasWallet] = useState(true);
    const [walletUrl, setWalletUrl] = useState("");
    const [loading, setLoading] = useState(true);

    const [newApps, setNewApps] = useState<GameInfo[]>([]);
    const [highlightApps, setHighlightApps] = useState<GameInfo[]>([]);
    const [usedApps, setUsedApps] = useState<GameInfo[]>([]);
    const [allApps, setAllApps] = useState<GameInfo[]>([]);

    const [view, setView] = useState("market");
    const [searchText, setSearchText] = useState('');
    
    const [contents, setContents] = useState<ContentInfo[]>([]);
    const [streams, setStreams] = useState<ContentInfo[]>([]);
    const [canRefresh, setCanRefresh] = useState(true);
    const [endOfContent, setEndOfContent] = useState(false);
    const [locationSelect, setLocationSelect] = useState(false);
    const [curLocation, setCurLocation] = useState(GetStr(LANGUAGE.TXT_MK_DEF_LOC));
    const [locationID, setLocationID] = useState("1");
    const [curCategory, setCurCategory] = useState("");
    const [categoryID, setCategoryID] = useState(10);
    const [categoroies, setCategories] = useState<string[]>([]);
    const [catSelect, setCatSelect] = useState(false);
    const [showSearch, setShowSearch] = useState(false);

    //	Initializing our router
	const router = useIonRouter();

    // need to refresh
    useEffect(() => {
        // init
        setView(match.params.tab);

        // refresh wallet
        if (match.params.tab == "wallet")
            loadWallet();
    },[match.params.tab]);

    useEffect(() => {
        // reload the view
        Refresh();
    },[view]);

    // search the marketplace
    useEffect( ()=> { 
        index = 0;
        loadMarket();
    }, [searchText]);

    // do a search 
    const doSearch = async () => {
        index = 0;
        setShowSearch(false);

        await loadMarket();
    }

    // change category, search market
    useEffect( ()=> { 
        // do a search
        index = 0;
        loadMarket();
    }, [categoryID]);

    // change location ID, search market
    useEffect( ()=> { 
        // do a search
        index = 0;
        loadMarket();
    }, [locationID]);

    useIonViewWillEnter(() => {
        RegisterAppServices();
    });

    const numberWithCommas = (x : string) => {
        return x.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    const Refresh = async () => {
        if (view == "wallet")
            await loadWallet();
        else if (view == "games")
            await loadGames();
        else
            await loadMarket();
    }

    // load the wallet info 
    const loadWallet = async () => {
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key
        }

		var server = new NServer();
        await server.getList("nc_wallet", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            setUsd(server.data.usd);
            setNToken(server.data.ntoken);
            setUsdExchange(server.data.usd_exchange);
            setNTKExchange(server.data.ntk_exchange);

            setHasWallet(server.data.passkey == "yes");
            setWalletUrl(server.data.nwallet);
        }

        setLoading(false);
    };

    // load the games info
    const loadGames = async () => {
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key
        }

		var server = new NServer();
        await server.getList("games", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            // update the UI
            setNewApps(server.data.new);

            setHighlightApps(server.data.highlight);

            setUsedApps(server.data.used);

            setAllApps(server.data.all);
        }

        setLoading(false);
    }

    // load the marketplace
    const loadMarket = async () => {
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            s: index,
            e: total,
            search: searchText,
            location: locationID,
            category: categoryID
        }

        var server = new NServer();
        await server.getList("nc_market", state);
        if (!server.success && server.message != "")
        {
            showAlert(server.message);

            handleRouteError(router, server.data);
        }
        else
        {
            const d = server.data;

            if (d != null)
            {
                var dataStream = null;
                if (server.data.stream != null)
                {
                    if (index == 0)
                        dataStream = server.data.stream;
                    else
                        dataStream = streams.concat(server.data.stream);
                    
                    // filter
                    dataStream = FilterUniqueContent(dataStream);
		            
                    setStreams(dataStream);
                }
                
                // if we reach end of data
                noMoreLoadData = server.data.nomore == "yes";
                index = server.data.index;

                let contentStream = dataStream;
                
                setContents(contentStream);

                setCategories(d.categories);
                
                setEndOfContent(noMoreLoadData);
            }
        }

        setLoading(false);
    }

    const doRefresh = async (ev : any) => {
        index = 0;
        await Refresh();
        ev.detail.complete();
    }

    const exchangeRate = (token : string) => {
        router.push("/exchangerate/" + token, "forward", "push");
    }

    // install the N-wallet
    const onInstallNWallet = () => {
        window.open(walletUrl);
    }

    // open the N-wallet
    const openNWallet = () => {
        window.open("nwm://nwallet.me?app");
    }

    // scroll event
    const onScrollTop = (val : boolean) => {
        setCanRefresh(val);
    }

    // load more data
    const loadMoreData = async () => {
        if (noMoreLoadData)
            return;

        await Refresh();
    }

    // update a content
    const onUpdateContent = (index : number, content : ContentInfo, local : boolean) => {
    }

    // select the current location
    const selectCurLocation = (loc : Location) => {
        setCurLocation(locationName(loc));
        setLocationID(loc.id);
    }

    // change the categories
    const changeCategory = (val : number) => {
        setCategoryID(val);
        setCurCategory(categoroies[val]);
    }

    // show the game
    const showGame = (g : GameInfo) => {
        if (g.weblink != "")
            router.push("/gamepage/" + g.id + "/n/n", "forward", "push");
        else
            router.push("/game/" + g.id, "forward", "push");
    }

    return (
        <IonPage>
            <IonContent>
                <IonRefresher  slot="fixed" onIonRefresh={doRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>
                { /* main tab */ }
                <IonSegment value={view} onIonChange={ (e) => { setView(e.detail.value!) }}>
                    <IonSegmentButton className={ UIElement("nc_market") } value="market">
                        <IonLabel color={ view=="market" ? "primary" : "medium" }><b><small>{ GetStr(LANGUAGE.TXT_BOX_MARKET) }</small></b></IonLabel>
                    </IonSegmentButton>
                    <IonSegmentButton className={ UIElement("nc_games") } value="games">
                        <IonLabel color={ view=="games" ? "primary" : "medium" }><b><small>{ GetStr(LANGUAGE.TXT_BOX_GAMES) }</small></b></IonLabel>
                    </IonSegmentButton>
                    <IonSegmentButton value="wallet">
                        <IonLabel color={ view=="wallet" ? "primary" : "medium" }><b><small>{ GetStr(LANGUAGE.TXT_BOX_WALLET) }</small></b></IonLabel>
                    </IonSegmentButton>
                </IonSegment>
                {
                    /* search bar for market */
                    view == "market" && !loading ?
                <IonToolbar color="none">
                    <IonSearchbar className="search-bubble" placeholder={ GetStr(LANGUAGE.TXT_MARKET_SEARCH) } value={searchText} onIonChange={ (e) => { setSearchText(e.detail.value!)}} ></IonSearchbar>
                </IonToolbar>
                    :
                <div/>
                }

                <IonGrid className={ "ion-no-padding tab-content" + (view == "market" ? " virtu-wrapper" : "") }>
                    <IonRow className="full-content">
                        <IonCol>
                        </IonCol>
                        <IonCol size-md="8" size-lg="6" size-xl="5" size-sm="10" size="12">
                            {
                                loading ?
                            <div className="flex-center">
                                <div className="spinnerCenter">
                                    <IonSpinner name="crescent" />
                                </div>
                            </div>
                                :
                                view == "market" ?
                            /* marketplace UI */
                            <Virtuoso id="market-con-view" className="ion-content-scroll-host"
                                atTopStateChange={onScrollTop}
                                defaultItemHeight={200}
                                data={contents}
                                totalCount={contents.length}
                                endReached={loadMoreData}
                                components={{
                                    Header: () => {
                                        return (
                                            <IonCard className="flat-card ion-no-margin">
                                                { /* header for market items search function */ }
                                                <div className="but-div-wrapper">
                                                    <div className="but-div">
                                                        <IonButton className="but-round text-nocap" expand="block" color="primary" onClick={ ()=> setCatSelect(true) }>
                                                            <IonIcon icon={listOutline} />&nbsp;
                                                            { curCategory == "" ? GetStr(LANGUAGE.TXT_MK_CATEGORIES) : curCategory }
                                                        </IonButton>
                                                    </div>
                                                    <div className="but-div">
                                                        <IonButton className="but-round text-nocap" expand="block" color="secondary" routerLink="/add/market">
                                                            <IonIcon icon={createOutline} />&nbsp;
                                                            { GetStr(LANGUAGE.TXT_MK_SELL) }
                                                        </IonButton>
                                                    </div>
                                                </div>
                                                <IonItem className="ion-activatable ripple-parent" lines="full" onClick={()=>setLocationSelect(true)}>
                                                    <IonIcon icon={locationOutline} />&nbsp;
                                                    <IonLabel><b><IonText color="primary">{ GetStr(LANGUAGE.TXT_MARKET_LOCATION) }</IonText></b>&nbsp;{ curLocation }</IonLabel>
                                                    <IonIcon icon={createOutline} />
                                                    <IonRippleEffect></IonRippleEffect>
                                                </IonItem>
                                            </IonCard>
                                        )
                                    },
                                }}
                                itemContent={(index, content) => 
                                    <ContentWrapper key={content.id} content={content} index={index} onUpdate={onUpdateContent} view="def" autoplay={false} />
                                }
                            >
                            </Virtuoso>
                                :
                                /* game view */
                                view == "games" ?
                            <div>
                                {
                                /* last used games */
                                    usedApps.length > 0 ?
                                <div>
                                    <div className="ion-padding-start">
                                        <h5>{ GetStr(LANGUAGE.TXT_GAMES_LAST_USED) }</h5>
                                    </div>
                                    <IonCard className="flat-card">
                                        <IonGrid fixed>
                                            <IonRow>
                                            { 
                                                usedApps.map((content, index) => (
                                            <IonCol className="game-slot" 
                                                size-lg="3" size-xl="3" size="4"
                                                key={index} onClick={()=> showGame(content)}>
                                                <IonImg className="game-slot-avt" src={content.icon} onError={ ({currentTarget}) => { currentTarget.src = "/assets/img/shop_avt.jpg" } } />
                                                <IonText className="game-slot-text">{ content.caption }</IonText>                
                                            </IonCol>
                                                ))
                                            }
                                            </IonRow>
                                        </IonGrid>
                                    </IonCard>
                                </div>
                                    :
                                <div/>
                                }

                                {
                                    /* new games */
                                    newApps.length > 0 ?
                                <div>
                                    <div className="ion-padding-start">
                                        <h5>{ GetStr(LANGUAGE.TXT_GAMES_NEW) }</h5>
                                    </div>
                                    <IonCard className="flat-card">
                                        { newApps.map((content, index) => (
                                        <IonItem className="ion-margin-top ion-margin-bottom" lines="none" key={content.id} onClick={()=> showGame(content)}>
                                            <IonImg className="game-avt" src={content.icon} onError={ ({currentTarget}) => { currentTarget.src = "/assets/img/shop_avt.jpg" } } />
                                            <IonLabel className="ion-text-wrap ion-margin-start">
                                                <h2><b>{ content.caption }</b></h2>                
                                                <IonNote><b>{ content.descrip }</b></IonNote>
                                            </IonLabel>
                                        </IonItem>
                                        ))}
                                    </IonCard>
                                </div>
                                    :
                                <div/>
                                }
                                <IonRow>
                                    <IonCol className="ion-padding-start">
                                        { highlightApps.length > 0 ? <h5>{ GetStr(LANGUAGE.TXT_GAMES_HIGHLIGHT) }</h5> : <div/> }
                                    </IonCol>
                                </IonRow>
                                {
                                    /* all highlighted games */
                                    highlightApps.length > 0 ?
                                <IonRow>
                                    <IonCol>
                                        <IonCard className="flat-card">
                                            { highlightApps.map((content, index) => (
                                            <IonItem className="ion-margin-top ion-margin-bottom" key={content.id} lines="none" routerLink={"/game/" + content.id} detail={true}>
                                                <IonImg className="game-avt-small" src={ content.icon } onError={ ({currentTarget}) => { currentTarget.src = "/assets/img/shop_avt.jpg" } } />
                                                <IonLabel className="ion-padding-start ion-text-wrap">
                                                    <h2><b>{ content.caption }</b></h2>                
                                                    <IonNote className="ion-text-nowrap"><i>{ content.tag }</i></IonNote>
                                                </IonLabel>
                                            </IonItem>
                                            ))}
                                        </IonCard>
                                    </IonCol>
                                </IonRow>
                                    :
                                <div/>
                                }
                                {
                                    /* all available games */
                                    allApps.length > 0 ?
                                <div>
                                    <div className="ion-padding-start">
                                        <h5>{ GetStr(LANGUAGE.TXT_GAMES_ALL) }</h5>
                                    </div>
                                    <IonCard className="flat-card">
                                        { allApps.map((content, index) => (
                                        <IonItem className="ion-margin-top ion-margin-bottom" key={content.id} lines="none" onClick={()=> showGame(content)} detail={true}>
                                            <IonImg className="game-avt-very-small" src={ content.icon } onError={ ({currentTarget}) => { currentTarget.src = "/assets/img/shop_avt.jpg" } } />
                                            <IonLabel className="ion-padding-start ion-text-wrap">
                                                <h2><b>{ content.caption }</b></h2>                
                                            </IonLabel>
                                        </IonItem>
                                        ))}
                                    </IonCard>
                                </div>
                                    :
                                <div/>
                                }
                            </div>
                                :
                                view == "wallet" ?
                            /* wallet view */
                            <div>
                                <IonGrid>
                                <IonRow>
                                <IonCol size-md="6" size="12">
                                <IonCard className="balance-card-nm flat-card card-shadow" >
                                    <div className="ion-text-center">
                                        {
                                            usd == "" ?
                                        <IonSpinner className="ion-margin" name="crescent" color="light" />
                                            :
                                        <IonText className="balance-text" color="light">${ numberWithCommas(usd) }</IonText>
                                        }
                                    </div>
                                    <div className="ion-text-center">
                                        <IonText color="light"><small>{ GetStr(LANGUAGE.TXT_USD_CAP) }</small></IonText>
                                    </div>
                                </IonCard>
                                </IonCol>

                                <IonCol size-md="6" size="12">
                                <IonCard className="token-card-nm flat-card card-shadow" >
                                    <div className="ion-text-center">
                                        {
                                            nToken == "" ?
                                        <IonSpinner className="ion-margin" name="crescent" color="light" />
                                            :
                                        <IonText className="balance-text" color="light">{ numberWithCommas(nToken) }</IonText>
                                        }
                                    </div>
                                    <div className="ion-text-center">
                                        <IonText color="light"><small>{ GetStr(LANGUAGE.TXT_NTOKEN_CAP) }</small></IonText>
                                    </div>
                                </IonCard>
                                </IonCol>
                                </IonRow>
                                { /* main functions */}
                                
                                    <IonRow>
                                        <IonCol size-md="3" size="6">
                                             <IonButton className="action-but" color="primary" expand="block" routerLink="/ntk_exchange" disabled={!hasWallet}>
                                                <IonIcon icon={shuffleOutline} size="large" />&nbsp;
                                                { GetStr(LANGUAGE.TXT_WALLET_EXCHANGE) }
                                            </IonButton>
                                        </IonCol>
                                        <IonCol size-md="3" size="6">
                                             <IonButton className="action-but" color="primary" expand="block" routerLink="/ntkbuy" disabled={!hasWallet}>
                                                <IonIcon icon={heartOutline} size="large" />&nbsp;
                                                { GetStr(LANGUAGE.TXT_WALLET_BUY_LIKE) }
                                            </IonButton>
                                        </IonCol>
                                        <IonCol size-md="3" size="6">
                                            <IonButton className="action-but" color="primary" expand="block" routerLink='/address'>
                                                <IonIcon icon={cardOutline} size="large" />&nbsp;
                                                { GetStr(LANGUAGE.TXT_WALLET_TOPUP) }
                                            </IonButton>
                                        </IonCol>
                                        <IonCol size-md="3" size="6">
                                            <IonButton className="action-but " color="primary" expand="block" routerLink="/withdraw" disabled={!hasWallet}>
                                                <IonIcon icon={enterOutline} size="large" />&nbsp;
                                                { GetStr(LANGUAGE.TXT_WALLET_WITHDRAW) }
                                            </IonButton>
                                        </IonCol>
                                    </IonRow>

                                    <IonRow>
                                        <IonCol>
                                            {
                                                !hasWallet ?
                                            <IonCard>
                                                <IonItem>
                                                    <IonAvatar slot="start">
                                                        <img src="/assets/img/forget_pass_pic.png"  />
                                                    </IonAvatar>
                                                    <IonLabel className="ion-text-wrap">
                                                        <h2>{ GetStr(LANGUAGE.TXT_WALLET_PASSKEY_CAP) }</h2>
                                                        <IonNote>{ GetStr(LANGUAGE.TXT_WALLET_PASSKEY_DESC) }</IonNote>
                                                    </IonLabel>
                                                </IonItem>
                                                <IonButton expand="block" fill="clear" routerLink="/lockset">
                                                    { GetStr(LANGUAGE.TXT_WALLET_PASSKEY_DO) }
                                                </IonButton>
                                            </IonCard>
                                                :
                                            <div/>
                                            }
                                        </IonCol>
                                    </IonRow>
                                </IonGrid>
                            </div>
                                :
                            <div/>
                            }
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                </IonGrid>
                <LocationSelector
                    isOpen={locationSelect}
                    onDidDismiss={ ()=> setLocationSelect(false) }
                    onSelect={ selectCurLocation }
                />

                <ItemSelector 
                    title={ GetStr(LANGUAGE.TXT_MK_SELECT_CATEGORY) }
                    isOpen={catSelect} 
                    onDidDismiss={ ()=> setCatSelect(false) }
                    onSelect={ (index:number)=> changeCategory(index) }
                    items={ categoroies }
                    selected={ categoryID } 
                />
            </IonContent>
        </IonPage>
    );
};

export default TokenWallet;